<template>
  <div
    class="imbee-loader-container"
    :style="{ backgroundColor: loaderBackground }"
  >
    <BeatLoader v-if="loader == 'BeatLoader'" v-bind:color="loaderColor" />
    <PropagateLoader
      v-if="loader == 'PropagateLoader'"
      v-bind:color="loaderColor"
    />
    <GridLoader
      v-if="loader == 'GridLoader'"
      v-bind:color="loaderColor"
      margin="10px"
    />
    <SquareLoader v-if="loader == 'SquareLoader'" v-bind:color="loaderColor" />
    <CircleLoader v-if="loader == 'CircleLoader'" v-bind:color="loaderColor" />
  </div>
</template>

<script>
import {
  BeatLoader,
  PropagateLoader,
  GridLoader,
  SquareLoader,
  CircleLoader,
} from "@saeris/vue-spinners";

export default {
  name: "LoaderContainer",
  components: {
    BeatLoader,
    PropagateLoader,
    GridLoader,
    SquareLoader,
    CircleLoader,
  },
  props: {
    loader: { type: String, default: "GridLoader" },
    loaderColor: { type: String, default: "#000" },
    loaderBackground: { type: String, default: "#FFF" },
  },
};
</script>

<style scoped>
.imbee-loader-container {
  height: 100%;
  width: 100%;
  border: 0px;
  border-radius: 0;
  display: -webkit-box; 
  display: -moz-box; 
  display: -ms-flexbox; 
  display: -webkit-flex; 
  display: flex; 
  justify-content: center;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// LoaderContainer.vue?cc93bf54